// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1ccce095","213":"058d8531","239":"4998d672","732":"bf9ab25b"}[chunkId] + ".chunk.js";
};